import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { EducateRoutingModule } from './educate-routing.module';
import { LayoutComponent } from './layout.component';
import { EducateComponent } from './educate.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatTimepickerModule } from 'mat-timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { IntroductionComponent } from './introduction.component';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Facts1Component } from './facts1.component';
import { Age2Component } from './age2.component';
import { Controls3Component } from './controls3.component';
import { Emotions4Component } from './emotions4.component';
import { Insomnia5Component } from './insomnia5.component';
import { Perpetuates6Component } from './perpetuates6.component';
import { Sleep1Component } from './sleep1.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    EducateRoutingModule,
    //BrowserAnimationsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatTimepickerModule,
    FormsModule,
    MatIconModule,
    NgxSliderModule,
    MatExpansionModule,
    MatSliderModule,
    NgScrollbarModule,
    MatCardModule,
    MatGridListModule,
    MatButtonModule,
    MatProgressBarModule,
  ],
  declarations: [
    LayoutComponent,
    EducateComponent,
    IntroductionComponent,
    Facts1Component,
    Age2Component,
    Controls3Component,
    Emotions4Component,
    Insomnia5Component,
    Perpetuates6Component,
    Sleep1Component,
  ],
})
export class EducateModule {}
